(function($) {
    $( document ).ready(() => {
        $('#hero__slide--images').slick({
            dots: false,
            arrows: false,
            pauseOnHover: false,
        });

        $('#hero__slide--content').slick({
            dots: false,
            asNavFor: '#hero__slide--images',
            nextArrow: '#hero-slider__next',
            prevArrow: '#hero-slider__prev',
            autoplay: true,
            autoplaySpeed: 6000,
            fade: true,
            pauseOnHover: false,
        })

        const contentHeight = $('.hero__slide.slick-active').height() + 100;
        $('#hero__slide--box').height( contentHeight );
        $('.auto-controls').height( contentHeight );

        $('#hero__slide--content').on( 'beforeChange', ( event, slick, currentSlide, nextSlide ) => {
            const contentHeight = $(`.hero__slide:eq(${nextSlide})`).height() + 100;
            $('#hero__slide--box').height( contentHeight );
            $('.auto-controls').height( contentHeight );

            $(`.auto-slideDOT`).removeClass('active')
            $(`.auto-slideDOT:eq(${nextSlide})`).addClass('active')
            
            $('.auto-controls .left .progress').removeClass('animateLeftProgress')
            $('.auto-controls .right .progress').removeClass('animateRightProgress')
        })

        $('#hero__slide--content').on( 'afterChange', ( event, slick, currentSlide ) => {
            if ( ! $('#auto-controls__pauseBTN').hasClass('paused') ) {
                $('.auto-controls .left .progress').addClass('animateLeftProgress')
                $('.auto-controls .right .progress').addClass('animateRightProgress')
            }
        })

        $('#auto-controls__pauseBTN').click(function() {
            $( this ).toggleClass('paused');

            if ( ! $( this ).hasClass('paused') ) {
                $('#hero__slide--content').slick('slickPlay')
                $('#slider-play').hide();
                $('#slider-pause').show();
                $('.auto-controls .left .progress').addClass('animateLeftProgress')
                $('.auto-controls .right .progress').addClass('animateRightProgress')
            } else {
                $('#hero__slide--content').slick('slickPause')
                $('#slider-pause').hide();
                $('#slider-play').show();
                $('.auto-controls .left .progress').removeClass('animateLeftProgress')
                $('.auto-controls .right .progress').removeClass('animateRightProgress')
            }
        })

    })
}(jQuery))